import * as API from './api';
import * as C from './constants';

export function LoadList(page = 1, search = '', filter = '') {
    return {
        type: `PROMISE`,
        actions: [C.QR_LOAD_START, C.QR_LOAD_FINISH, C.QR_LOAD_ERROR],
        promise: API.loadQrList(page, search, filter),
    };
}

export function CreateQr(data = {}) {
    return {
        type: `PROMISE`,
        actions: [C.QR_CREATE_START, C.QR_CREATE_FINISH, C.QR_CREATE_ERROR],
        promise: API.createQrCode(data),
    };
}

export function UpdateQr(id = '', data = {}) {
    return {
        type: `PROMISE`,
        actions: [C.QR_UPDATE_START, C.QR_UPDATE_FINISH, C.QR_UPDATE_ERROR],
        promise: API.updateQrCode(id, data),
    };
}

export function DeleteQr(id = '') {
    return {
        type: `PROMISE`,
        actions: [C.QR_DELETE_START, C.QR_DELETE_FINISH, C.QR_DELETE_ERROR],
        promise: API.deleteQr(id),
    };
}

export function LoadStats() {
    return {
        type: `PROMISE`,
        actions: [C.QR_STATS_START, C.QR_STATS_FINISH, C.QR_STATS_ERROR],
        promise: API.loadStats(),
    };
}



// WEBPACK FOOTER //
// ./src/containers/qr/actions.js